<script setup>
import apiManager from '@/api';
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import AppointmentCalendar from './AppointmentCalendar.vue';

const props = defineProps({
  id: String,
});

const appointments = ref([]);

const loadAppointments = async () => {
  const { data } = await apiManager.appointments.getByEventId(props.id);
  appointments.value = data;
};

const store = useStore();
const event = computed(() => store.getters['events/event'](props.id));

loadAppointments();
</script>
<template>
  <appointment-calendar
    @refresh="loadAppointments"
    :appointments="appointments"
    :event="event"/>
</template>
